"use client";

import { useOnClickOutside } from "@/app/hooks/useOnClickOutside";
import clsx from "clsx";

import { useState } from "react";
import { DropdownButton } from "../DropdownButton";
import { Dropdown } from "./Dropdown";

type Props = {
  value: string;
  options: { label: string; value: string }[];
  name: string;
  id: string;
  onChange: (value: string) => void;
  placeholder?: string;
  title?: string;
  className?: string;
  isFullScreenModal?: boolean;
};

export const RadioDropdown = ({
  value,
  options,
  name,
  onChange,
  placeholder,
  className,
  title,
  isFullScreenModal = false,
}: Props) => {
  const [isOpen, setOpen] = useState(false);
  const ref = useOnClickOutside<HTMLDivElement>(() => setOpen(false));
  const currentOption = options.find((option) => option.value === value);

  return (
    <div
      className={clsx("relative block md:inline-block", className)}
      ref={ref}
    >
      <DropdownButton onClick={() => setOpen((prev) => !prev)}>
        {currentOption?.label ?? placeholder}
      </DropdownButton>
      {isOpen && (
        <Dropdown
          name={name}
          onChange={onChange}
          onClose={() => setOpen(false)}
          options={options}
          value={value}
          title={title}
          isFullScreenModal={isFullScreenModal}
        />
      )}
    </div>
  );
};
